export const enClientPortalErrorPagePages = {
    errorPage: {
        status: {
            unauthorized: {
                title: '401 Access denied',
                message:
                    'Your access was denied. Please try signing out and signing back in, or refresh the page. If the problem persists, contact support.',
            },
            forbidden: {
                title: '403 Access denied',
                message: 'You do not have permission to access this page. Contact support if needed.',
            },
            notFound: {
                title: '404 Page not found',
                message: 'Sorry, something seems to have gone wrong here. The page you are looking for could not be found.',
            },
            default: {
                title: 'Oops...',
                message: 'Sorry, an unexpected error occurred.',
            },
        },
        emptyState: {
            title: 'Welcome to einwert',
            assets: 'There is nothing to see here yet. Either you do not have permission or we have not completed your first valuation yet.',
            analysis:
                'There is nothing to see here yet. Either you do not have permission or your first valuation is not complete yet. Once it is complete, you can compare your assets here.',
            default:
                'There is nothing to see here yet. Either you do not have permission or your first valuation is not complete yet. Once it is complete, you will see your overview here.',
        },
        actions: {
            orders: 'Valuation orders',
            signOut: 'Sign out',
            back: 'Back',
            overview: 'Overview',
        },
        supportHint: 'If the error persists, contact',
    },
    welcomePage: {
        title: 'Welcome to einwert',
        message: 'Before you start, please complete your user profile by clicking the button below.',
        profile: 'Go to profile',
    },
}
